import React, { type JSX } from 'react';

import classNames from 'classnames';

import styles from './Card.module.css';

interface CardProps extends Omit<React.ComponentProps<'div'>, 'className'> {
  noShadow?: boolean;
  noHover?: boolean;
  elevated?: boolean;
  className?: string;
}

function Card({
  className,
  noShadow = false,
  noHover = false,
  elevated = false,
  children,
  ...props
}: CardProps): JSX.Element {
  return (
    <div
      className={classNames(
        styles.Card,
        noShadow && styles.noShadow,
        noHover && styles.noHover,
        elevated && styles.elevated,
        className,
      )}
      {...props}
      data-rv-surface=""
    >
      {children}
    </div>
  );
}

function CardHeader({ className, ...props }: React.ComponentProps<'div'>): JSX.Element {
  return (
    <div className={classNames(styles.CardHeader, className)} {...props}>
      {props.children}
    </div>
  );
}

function CardTitle({ className, ...props }: React.ComponentProps<'h3'>): JSX.Element {
  return <h3 className={classNames(styles.CardTitle, className)}>{props.children}</h3>;
}

function CardDescription({ className, ...props }: React.ComponentProps<'p'>): JSX.Element {
  return (
    <p className={classNames(styles.CardDescription, className)} {...props}>
      {props.children}
    </p>
  );
}

function CardContent({ className, ...props }: React.ComponentProps<'div'>): JSX.Element {
  return (
    <div className={classNames(styles.CardContent, className)} {...props}>
      {props.children}
    </div>
  );
}

export { Card, CardContent, CardDescription, CardHeader, CardTitle };
